export default "/react/logoLens-9e8fb4a1.png";